import { VisuallyHidden } from "@99tech/ui";
import { Box, Stack } from "@mui/material";
import React, { useCallback, useContext } from "react";
import { AppDownload, BtnLogin, BtnRegister, Logo, SlotGames } from "src/assets";
import { FloatingBanner } from "src/main/components";
import { AppContext } from "src/main/constants";
import { createStyles, isMobile } from "src/main/utils";

interface LandingPageProps extends React.PropsWithChildren {}

const LandingPage: React.FC<LandingPageProps> = (props) => {
  const { urls } = useContext(AppContext);
  const { loginUrl, registerUrl } = urls ?? {};

  const handleClick = useCallback(
    (type: "login" | "register") => (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (type === "login") {
        window.open(loginUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      } else {
        window.open(registerUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      }
    },
    [loginUrl, registerUrl],
  );

  return (
    <Box sx={styles.root}>
      <VisuallyHidden as="h1">KBK99</VisuallyHidden>
      <Stack
        alignItems="center"
        justifyContent="center"
      >
        <img
          alt="logo"
          src={Logo}
          width={286}
          style={{ marginTop: -4 }}
        />
        <Stack
          direction="row"
          spacing={1}
          mt={-1}
          zIndex={11}
        >
          <a
            href={loginUrl}
            onClick={handleClick("login")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="login button"
              src={BtnLogin}
              height={54}
              style={{ marginTop: 2 }}
            />
          </a>
          <a
            href={registerUrl}
            onClick={handleClick("register")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="register button"
              src={BtnRegister}
              height={54}
            />
          </a>
        </Stack>
      </Stack>

      <img
        alt="hero coins"
        src={SlotGames}
        style={{
          width: 400,
          marginTop: "-8px",
        }}
      />

      <img
        alt="app download"
        src={AppDownload}
        width={200}
        style={{ marginTop: "8px" }}
      />

      <FloatingBanner />
    </Box>
  );
};

const styles = createStyles({
  root: {
    background: `radial-gradient(50% 25% at 50% 0%, #EB81FF 0%, rgba(55, 4, 81, 0.00) 100%, rgba(0, 0, 0, 0.00) 100.01%)`,
    p: 0,
    pt: "16px",

    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    overflowX: "hidden",
    color: "#fff",
  },
  images: {
    marginTop: -3,
    zIndex: 10,
    position: "relative",
    width: "360px",
    height: "400px",
    img: {
      position: "absolute",
    },
  },
  footer: {
    zIndex: 0,
    position: "fixed",
    bottom: "0",
    width: "100vw",
    height: "200px",
    flexShrink: 0,
  },
});

export default LandingPage;
